/**
 * Deep link into a Calculation Builder wizard step: `/calculations/builder/<id>?step=N`.
 *
 * Calc Builder normally picks its landing step from the calculation's state (a reviewed CLI opens on
 * Step 5, Review journal entries). A caller that wants a specific step — e.g. the LEF report's
 * "GL Balance" source chip, whose origin is Step 2, Data Sources — appends `?step=N`. The view applies
 * it once, after the state-driven default has settled, so it wins over that default without
 * interfering with later navigation.
 */
export const WIZARD_STEP_QUERY_PARAM = 'step';

/** Step numbers as shown in the wizard bar. */
export const WIZARD_STEP_NUMBER = Object.freeze({
    SELECT_AGREEMENT: 1,
    DATA_SOURCES: 2,
    CALCULATION_STEPS: 3,
    JE_SETTINGS: 4,
    JE_REVIEW: 5,
    PLI_CONFIG: 6,
});

/** Appends `?step=N` to a Calc Builder URL; returns the URL unchanged when no step is given. */
export function withWizardStep(url: string, step?: number): string {
    return step == null ? url : `${url}?${WIZARD_STEP_QUERY_PARAM}=${step}`;
}

/**
 * The step requested in a location search string, or null when absent or not one of the wizard's
 * steps (non-numeric, zero, negative, or beyond `stepCount`).
 */
export function parseRequestedWizardStep(search: string | null | undefined, stepCount: number): number | null {
    const raw = new URLSearchParams(search ?? '').get(WIZARD_STEP_QUERY_PARAM);
    if (raw == null || !/^\d+$/.test(raw.trim())) {
        return null;
    }
    const step = Number(raw);
    return step >= 1 && step <= stepCount ? step : null;
}
